<span class="toolbar-button">
    <button class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" (click)="clickGoTpQuickStartGuide()"
        aria-label="Open PREP Quick Start Guide" matTooltip="PREP Quick Start Guide"
        matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
        <mat-icon aria-hidden="true">topic</mat-icon>
    </button>
</span>